import React from 'react';
import { useTranslation } from 'react-i18next';

const Datenschutz = () => {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-cream-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-serif font-light text-charcoal mb-8">Datenschutzerklärung</h1>

        <div className="space-y-10 text-charcoal">

          {/* 1. Einleitung */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">1. Einleitung</h2>
            <p className="font-light leading-relaxed text-sm">
              Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten wir bei Nutzung unserer Website
              <span className="font-medium"> Mind’UP</span> erheben, zu welchem Zweck wir diese verwenden und welche Rechte Ihnen als betroffene Person
              zustehen. Wir behandeln Ihre Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Erklärung.
            </p>
          </section>

          {/* 2. Verantwortliche Stelle */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">2. Verantwortliche Stelle</h2>
            <p className="font-light leading-relaxed text-sm">
              Verantwortlich im Sinne der DSGVO ist:
            </p>
            <div className="mt-3 rounded-lg bg-warm-sage/10 border border-warm-sage/30 p-4 text-sm">
              <p className="leading-relaxed">
                <span className="font-medium">Sanaa Ait Balla – Coaching &amp; Beratung</span><br />
                <span className="font-semibold text-warm-sage">[BITTE ANSCHRIFT EINFÜGEN]</span><br />
                <span className="font-semibold text-warm-sage">[BITTE PLZ UND ORT EINFÜGEN]</span><br />
                E-Mail:&nbsp;
                <span className="font-semibold text-warm-sage">[BITTE E-MAIL FÜR DATENSCHUTZANFRAGEN EINFÜGEN]</span>
              </p>
            </div>
            <p className="font-light leading-relaxed text-sm mt-3">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
              Verarbeitung von personenbezogenen Daten entscheidet.
            </p>
          </section>

          {/* 3. Hosting & Server-Logfiles */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">3. Hosting &amp; Server-Logfiles</h2>
            <p className="font-light leading-relaxed text-sm">
              Unsere Website wird bei <span className="font-medium">Hostinger International Ltd.</span> gehostet. Alle über die Website erhobenen Daten werden auf Servern
              unseres Hosters gespeichert. Hierzu zählen insbesondere IP-Adresse (in Server-Protokollen), Zeitpunkt und Dauer des Zugriffs, angeforderte Inhalte,
              Referrer-URL, Browser- und Systeminformationen. Die Verarbeitung dient der Bereitstellung, Sicherheit (Missbrauchs-/Angriffserkennung),
              Stabilität und Fehleranalyse der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
            </p>
            <p className="font-light leading-relaxed text-sm mt-3">
              Mit Hostinger besteht ein Auftragsverarbeitungsvertrag (Art. 28 DSGVO), der sicherstellt, dass Daten nur nach unseren Weisungen verarbeitet werden.
              Die Website wurde technisch durch <span className="font-medium">Emergent (Websitetreiber)</span> erstellt; auch hier besteht ein Auftragsverarbeitungsvertrag.
              Emergent erhält nur insoweit Zugriff, wie es für Wartung und Betrieb erforderlich ist.
            </p>
            <p className="font-light leading-relaxed text-sm mt-3">
              <span className="font-medium">Server-Logfiles:</span> Hostinger verarbeitet zu Sicherheits- und Betriebszwecken u. a. IP-Adresse (gekürzt), Datum/Uhrzeit, angeforderte Ressource,
              Referrer-URL, User-Agent. Eine Zusammenführung mit anderen Daten findet nicht statt. Die Protokolle werden in der Regel
              nach kurzer Frist gelöscht (spätestens 30 Tage), soweit keine längere Aufbewahrung aus Beweisgründen erforderlich ist.
            </p>
          </section>

          {/* 4. Kommunikation & Kontaktformular */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">4. Kontaktaufnahme &amp; Formulare</h2>
            <p className="font-light leading-relaxed text-sm">
              Bei Kontakt per E-Mail, Telefon oder über das Kontaktformular verarbeiten wir die von Ihnen mitgeteilten Daten (z. B. Name, E-Mail-Adresse,
              Inhalt der Nachricht) zur Bearbeitung und Beantwortung Ihrer Anfrage sowie für Anschlussfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
              (vorvertragliche/vertragliche Kommunikation) oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Kommunikation).
              Die Daten werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind, es sei denn, gesetzliche Aufbewahrungspflichten stehen entgegen.
            </p>
          </section>

          {/* 5. Dienstleistungen, Zahlung, Online-Coachings */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">5. Dienstleistungen, Zahlung &amp; Online-Coachings</h2>
            <p className="font-light leading-relaxed text-sm">
              Bei Buchung unserer Coaching-Leistungen verarbeiten wir Vertrags- und Kontaktdaten zur Durchführung und Abwicklung (Art. 6 Abs. 1 lit. b DSGVO).
              Zahlungen können per <span className="font-medium">PayPal</span> oder per Rechnung erfolgen. Bei PayPal erfolgt die Zahlungsabwicklung über PayPal (Europe) S.à r.l. et Cie, S.C.A.;
              PayPal erhält die zur Abwicklung erforderlichen Daten. Hinweise zum Datenschutz von PayPal finden Sie unter der dortigen Datenschutzerklärung.
              Bei Rechnung verarbeiten wir Ihre Daten zur ordnungsgemäßen Rechnungsstellung und, soweit erforderlich, zur Erfüllung gesetzlicher Aufbewahrungspflichten.
            </p>
            <p className="font-light leading-relaxed text-sm mt-3">
              Coachings können online (z. B. via Zoom oder Google Meet) oder persönlich stattfinden. Es werden <span className="font-medium">keine Sitzungen aufgezeichnet</span>.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Bei Nutzung US-amerikanischer Anbieter kann eine Drittlandübermittlung stattfinden; es werden geeignete Garantien
              (z. B. EU-Standardvertragsklauseln) eingesetzt, um ein angemessenes Datenschutzniveau zu gewährleisten.
            </p>
          </section>

          {/* 6. Bilder & Testimonials */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">6. Bilder &amp; Testimonials</h2>
            <p className="font-light leading-relaxed text-sm">
              Wir verwenden eigene Fotos sowie lizenzfreie Bilder (z. B. von Unsplash/Pexels). Soweit wir Testimonials mit Namen, Funktion oder Ort veröffentlichen,
              geschieht dies ausschließlich mit <span className="font-medium">ausdrücklicher Einwilligung</span> der betroffenen Personen (Art. 6 Abs. 1 lit. a DSGVO).
              Eine Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden; Inhalte werden dann umgehend entfernt, sofern keine gesetzlichen
              Aufbewahrungspflichten entgegenstehen.
            </p>
          </section>

          {/* 7. Cookies, Analyse, Newsletter – status jetzt/zukünftig */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">7. Cookies, Analyse &amp; Newsletter</h2>

            <h3 className="text-lg font-medium text-charcoal mb-2">7.1 Technisch notwendige Cookies</h3>
            <p className="font-light leading-relaxed text-sm">
              Wir verwenden technisch notwendige Cookies (z. B. für Sprachauswahl oder Consent-Speicherung), um die Grundfunktionen der Website bereitzustellen.
              Rechtsgrundlagen: Art. 6 Abs. 1 lit. f DSGVO i. V. m. § 25 Abs. 2 TTDSG.
            </p>

            <h3 className="text-lg font-medium text-charcoal mb-2 mt-4">7.2 Statistik- &amp; Marketing-Tools (zukünftig)</h3>
            <p className="font-light leading-relaxed text-sm">
              Derzeit setzen wir keine Analyse-, Tracking- oder Marketing-Tools ein. Zukünftig können Dienste wie Google Analytics oder Facebook Pixel
              hinzukommen. Vor Aktivierung werden wir ein rechtskonformes Consent-Banner implementieren und Ihre <span className="font-medium">Einwilligung</span> nach
              § 25 Abs. 1 TTDSG und Art. 6 Abs. 1 lit. a DSGVO einholen. Ohne Einwilligung werden keine optionalen Cookies gesetzt.
            </p>

            <h3 className="text-lg font-medium text-charcoal mb-2 mt-4">7.3 Newsletter (zukünftig)</h3>
            <p className="font-light leading-relaxed text-sm">
              Aktuell bieten wir keinen Newsletter an. Sollte künftig ein Newsletter eingeführt werden, erfolgt die Anmeldung im Double-Opt-In-Verfahren.
              Ihre E-Mail-Adresse wird dann nur zum Versand genutzt; die Einwilligung können Sie jederzeit widerrufen. Die Details (Versanddienstleister,
              Auftragsverarbeitung, Abmeldemöglichkeit) werden wir in dieser Erklärung ergänzen.
            </p>
          </section>

          {/* 8. Betroffenenrechte */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">8. Ihre Rechte</h2>
            <p className="font-light leading-relaxed text-sm">
              Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung
              (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch (Art. 21 DSGVO). Einwilligungen können Sie jederzeit mit Wirkung für
              die Zukunft widerrufen (Art. 7 Abs. 3 DSGVO). Zudem steht Ihnen das Recht zu, sich bei einer Datenschutzaufsichtsbehörde zu beschweren (Art. 77 DSGVO).
            </p>
          </section>

          {/* 9. Datensicherheit */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">9. Datensicherheit</h2>
            <p className="font-light leading-relaxed text-sm">
              Wir nutzen SSL-/TLS-Verschlüsselung und setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre Daten vor Verlust, Zerstörung
              und unbefugtem Zugriff zu schützen. Diese Maßnahmen werden laufend an den Stand der Technik angepasst.
            </p>
          </section>

          {/* 10. Drittstaatentransfers */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">10. Übermittlungen in Drittländer</h2>
            <p className="font-light leading-relaxed text-sm">
              Sofern personenbezogene Daten in Drittländer (insb. USA) übertragen werden, stellen wir ein angemessenes Datenschutzniveau sicher –
              etwa durch Angemessenheitsbeschlüsse oder EU-Standardvertragsklauseln sowie zusätzliche Schutzmaßnahmen. Die betroffenen Dienste
              (z. B. Videokonferenz- oder Zahlungsanbieter) werden in dieser Erklärung konkret benannt, sobald sie produktiv eingesetzt sind.
            </p>
          </section>

          {/* 11. Pflicht zur Bereitstellung */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">11. Pflicht zur Bereitstellung von Daten</h2>
            <p className="font-light leading-relaxed text-sm">
              Es besteht grundsätzlich keine gesetzliche Pflicht, Daten bereitzustellen. Für die Bearbeitung von Anfragen oder die Durchführung unserer
              Leistungen können bestimmte Angaben erforderlich sein. Ohne diese können wir Ihr Anliegen ggf. nicht bearbeiten oder Leistungen nicht erbringen.
            </p>
          </section>

          {/* 12. Änderungen / Stand */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">12. Änderungen dieser Datenschutzerklärung</h2>
            <p className="font-light leading-relaxed text-sm">
              Wir behalten uns vor, diese Erklärung anzupassen, um sie an rechtliche Vorgaben oder Leistungsänderungen anzupassen. Für Ihren erneuten Besuch gilt
              die jeweils aktuelle Version auf dieser Website.
            </p>
            <p className="font-light leading-relaxed text-sm mt-3">
              <span className="font-medium">Stand:</span>&nbsp;
              <span className="font-semibold text-warm-sage">[BITTE AKTUELLES DATUM EINFÜGEN]</span>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
